import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';

import { Page } from '../../../../lib/lib-ngx/utils/Page';
import { ApiLavandierService } from '../../../../lib/lib-ngx/web-services/api-lavandier.service';
import { IOrderShipReturnDetailsListReadyToValidate } from '../../../../lib/lib-shared/models/OrderShipReturn';
import { ITransportSheet } from '../../../../lib/lib-shared/models/TransportSheet';
import {
  OrderShipReturnValidateModalComponent
} from '../../modals/order-ship-return-validate-modal/order-ship-return-validate-modal.component';

@Component({
  selector: 'lm-order-ship-return-list',
  templateUrl: './order-ship-return-list.component.html',
  styleUrls: ['./order-ship-return-list.component.scss']
})
export class OrderShipReturnListComponent implements OnInit {
  page = new Page();

  public orderList: IOrderShipReturnDetailsListReadyToValidate[] = [];
  public filterForm = this.fb.group({
    ref: [''],
    orderId: [''],
  });

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private apiLavandierService: ApiLavandierService,
    private modalService: NgbModal,
  ) {
    this.page.setPageNumber(0);
    this.page.size = 10;
  }

  ngOnInit() {
    this.filterForm.valueChanges
      .pipe(
        debounceTime(200),
        distinctUntilChanged(),
        switchMap(data => {
          this.page.checkPage();
          const ref = data.ref.trim();
          const orderId = data.orderId.trim();
          return this.apiLavandierService.getOrderShipReturnReadyToValidate({
            ...ref && {ref},
            ...orderId && {orderId: Number(orderId)},
            ...this.page.toNumberObject(),
          });
        }),
      )
      .subscribe(orderList => {
        this.page.totalElements = orderList.count;
        this.page.totalPages = this.page.totalElements / this.page.size;
        this.orderList = orderList.rows;
      });
    this.filterForm.updateValueAndValidity();
  }

  setPage(pageInfo) {
    this.page.setPageNumber(pageInfo.offset);
    this.filterForm.updateValueAndValidity();
  }

  getPreviousTransportSheetList(row: IOrderShipReturnDetailsListReadyToValidate): ITransportSheet[] {
    const previous = row.order.orderShipReturnList
      .filter(orderShipReturn => orderShipReturn.id < row.id)
      .sort((a, b) => b.id - a.id)[0];
    return previous ? previous.transportSheetList : [];
  }

  navigateToOrderDetail(event) {
    if (event.type === 'click') {
      this.router.navigate(['order-details', event.row.order.id]);
    }
  }

  onValidateOrderShipReturn(event, orderShipReturn: IOrderShipReturnDetailsListReadyToValidate) {
    event.stopPropagation();
    const validateModal = this.modalService.open(OrderShipReturnValidateModalComponent, {size: 'lg'});
    validateModal.componentInstance.orderType = orderShipReturn.order.type;
    validateModal.result.then(result => {
      if (result) {
        this.apiLavandierService.putOrderShipReturnValidate(orderShipReturn.id, {
          freeReturn: result.freeReturn,
        })
          .subscribe(() => this.filterForm.updateValueAndValidity());
      }
    }).catch(() => null);
  }
}
